import { type TFunction } from 'i18next';
import { type Facet, type SelectOption } from '../../../../_types/Car';
import stringToSlug from '../../../../utils/string-to-slug';

export const arrAus: (translate: TFunction) => Facet[] = (translate) => {
    const arr: SelectOption[] = [
        // Innen
        { i: '36', t: translate('common:car.aus.innen.36'), group: translate('common:car.aus.innen.title') },
        { i: '27', t: translate('common:car.aus.innen.27'), group: translate('common:car.aus.innen.title') },
        { i: '1119', t: translate('common:car.aus.innen.1119'), group: translate('common:car.aus.innen.title') },

        { i: '278', t: translate('common:car.aus.innen.278'), group: translate('common:car.aus.innen.title') },
        { i: '22', t: translate('common:car.aus.innen.22'), group: translate('common:car.aus.innen.title') },
        { i: '81', t: translate('common:car.aus.innen.81'), group: translate('common:car.aus.innen.title') },

        { i: '29', t: translate('common:car.aus.innen.29'), group: translate('common:car.aus.innen.title') },
        { i: '23', t: translate('common:car.aus.innen.23'), group: translate('common:car.aus.innen.title') },
        { i: '24', t: translate('common:car.aus.innen.24'), group: translate('common:car.aus.innen.title') },

        // Aussen
        { i: '1140', t: translate('common:car.aus.aussen.1140'), group: translate('common:car.aus.aussen.title') },
        { i: '88', t: translate('common:car.aus.aussen.88'), group: translate('common:car.aus.aussen.title') },
        { i: '238', t: translate('common:car.aus.aussen.238'), group: translate('common:car.aus.aussen.title') },

        { i: '41', t: translate('common:car.aus.aussen.41'), group: translate('common:car.aus.aussen.title') },
        { i: '71', t: translate('common:car.aus.aussen.71'), group: translate('common:car.aus.aussen.title') },
        { i: '34', t: translate('common:car.aus.aussen.34'), group: translate('common:car.aus.aussen.title') },

        // Assistenz
        { i: '332', t: translate('common:car.aus.assistenz.332'), group: translate('common:car.aus.assistenz.title') },
        { i: '26', t: translate('common:car.aus.assistenz.26'), group: translate('common:car.aus.assistenz.title') },
        { i: '514', t: translate('common:car.aus.assistenz.514'), group: translate('common:car.aus.assistenz.title') },

        { i: '25', t: translate('common:car.aus.assistenz.25'), group: translate('common:car.aus.assistenz.title') },
        { i: '402', t: translate('common:car.aus.assistenz.402'), group: translate('common:car.aus.assistenz.title') },
        { i: '1145', t: translate('common:car.aus.assistenz.1145'), group: translate('common:car.aus.assistenz.title') },

        { i: '515', t: translate('common:car.aus.assistenz.515'), group: translate('common:car.aus.assistenz.title') },
        { i: '48', t: translate('common:car.aus.assistenz.48'), group: translate('common:car.aus.assistenz.title') },

        // Sonstiges
        { i: '61', t: translate('common:car.aus.sonstiges.61'), group: translate('common:car.aus.sonstiges.title') },
    ];

    return arr?.map((el) => ({ ...el, tSlug: stringToSlug(el?.t) }));
};
